<template>
    <ul class="nav nav-tabs">
        <li :class="{ 'active': isActiveTab('operatorBaseData') }">
            <router-link :to="{ name: 'operatorBaseData', params: {'id': operatorId} }">{{ $label('operator.base_data_tab') }}</router-link>
        </li>

        <li :class="{ 'active': isActiveTab('operatorInvoiceSettings') }">
            <router-link :to="{ name: 'operatorInvoiceSettings', parmas: {'id': operatorId} }">{{ $label('operator.invoice_settings_tab') }}</router-link>
        </li>

        <!-- <li :class="{ 'active': isActiveTab('operatorSmsQuota') }">
            <router-link :to="{ name: 'operatorSmsQuota', params: {'id': operatorId} }">{{ $label('operator.sms_quota_tab') }}</router-link>
        </li> -->

        <li :class="{ 'active': isActiveTab('operatorEmailSettings') }">
            <router-link :to="{ name: 'operatorEmailSettings', params: {'id': operatorId} }">{{ $label('operator.email_settings_tab') }}</router-link>
        </li>

        <li :class="{ 'active': isActiveTab('listOperators') }">
            <router-link :to="{ name: 'listOperators' }">{{ $label('operator.additional_operators_tab') }}</router-link>
        </li>
    </ul>
</template>

<script>
export default {
    props: ['operatorId'],

    methods: {
        isActiveTab(tab) {
            return this.$route.name == tab;
        },
    },
}
</script>
